<ng-container *ngIf="!showDetailsClubPriority">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">

    <ng-container matColumnDef="clubCode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="clubCode" class="cell_code_club"> Code
      </th>
      <td mat-cell *matCellDef="let element" class="cell_code_club"> {{element.clubCode}} </td>
    </ng-container>

    <ng-container matColumnDef="clubName">
      <!-- <th mat-header-cell *matHeaderCellDef mat-sort-header="clubName" class="cell_club">Nom du club </th> -->
      <th mat-header-cell *matHeaderCellDef mat-sort-header="clubName" class="cell_club">Nom de l'acteur </th>
      <td mat-cell *matCellDef="let element" class="cell_club"> {{element.clubName}} </td>
    </ng-container>

    <ng-container matColumnDef="offerPrioritized">
      <!-- <th mat-header-cell *matHeaderCellDef class="cell_priority"> Offres prioritaires </th> -->
      <th mat-header-cell *matHeaderCellDef class="cell_priority"> Articles prioritaires </th>
      <td mat-cell *matCellDef="let element" class="cell_priority">
        {{element?.priorities}}/{{element?.limitPriorities}}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef class="cell_action"> Editer </th>
      <td mat-cell *matCellDef="let element" class="cell_action">
        <fa-icon [icon]="getFaIcon('faPen')" (click)="goDetailsClub(element)"  appChangeColorTheme attribute="color">
        </fa-icon>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
    </tr>
  </table>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"
    [color]="color">
  </mat-paginator>
</ng-container>

<app-admin-offer-priority-solo  *ngIf="showDetailsClubPriority" [clubCode]="clubCode" ></app-admin-offer-priority-solo>
